module.exports = __webpack_public_path__ + "static/media/w (11).d7935e1c.jpg";